import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Applicant } from '../../../redux-store/types/api-types';
import { formatShortDate } from '../../../utils/date';
import { KeyValue } from '../../ApplicationDetails/InvestorWithoutPan/contributor';
import { Gridstyles, Item, ItemDetails } from '../../ApplicationDetails';
import { SubHeading } from '../../investors/components';
import {
  checkRelationshipWithPep,
  currencyConversion,
  getRelationshipWithPepLabel,
  isIdTypeOutOfList,
  IsInvestorWithPAN,
} from '../../../utils/utilityFunctions';
import {
  ApplicationSourceMaster,
  ONBOARDING_ID_TYPES_MASTER,
  investorTypeMasters,
} from '../../../utils/constant';

export default function ContributorDetails({
  applicants = [],
  applicationSource,
  flowType,
  ifXalt,
}: {
  applicants: Partial<Applicant>[];
  applicationSource: string | undefined;
  flowType: string;
  ifXalt: boolean;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              {/* <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Application Source:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                  }}>
                  {applicationSource ? ApplicationSourceMaster[applicationSource] : 'N/A'}
                </Typography>
              </Typography> */}
            </Grid>
            {applicants.map((applicant) => {
              return (
                <React.Fragment key={applicant.id}>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name Of Entity'} description={applicant.name} />
                      <KeyValue
                        title={'Date of Registration/Incorporation'}
                        description={formatShortDate(applicant.dateOfBirth)}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'Place of Registration/Incorporation'}
                        description={applicant.cityOfIncorporation}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      {/* <KeyValue
                        title={'CKYC No./CKYC Acknowledge No./KIN No'}
                        description={applicant.ckycNo}
                      /> */}
                      {applicant.investorType && (
                        <KeyValue
                          title={'Investor Type'}
                          description={investorTypeMasters[applicant.investorType]}
                        />
                      )}
                      <KeyValue
                        title={`${
                          applicant.onboardingIdType && applicant.onboardingIdType
                            ? !isIdTypeOutOfList(applicant.onboardingIdType || '')
                              ? ONBOARDING_ID_TYPES_MASTER[applicant.onboardingIdType || '']
                              : applicant?.onboardingIdTypeOthers
                            : 'Id Number'
                        }`}
                        description={applicant.taxIdNumber}
                      />
                      <KeyValue
                        title={'Corporate Identification number (if applicable)'}
                        description={applicant.corporateIdentificationNo}
                      />
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={21}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Gross Annual Income in USD'}
                        description={applicant.grossAnnualIncome}
                      />
                      <Grid item xs={12} sm={6}>
                        <Item>{'Net Worth in USD'}</Item>
                        <ItemDetails> {applicant.netWorth ? applicant.netWorth : '-'}</ItemDetails>
                        {applicant.netWorth && Number(applicant.netWorth) > 0 && (
                          <Item>{currencyConversion(applicant.netWorth, 'usd')}</Item>
                        )}
                      </Grid>
                      <KeyValue
                        title={'Politically Exposed Person (PEP) Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />
                      {checkRelationshipWithPep(applicant.politicallyExposedPersonStatus || '') && (
                        <KeyValue
                          title={`${getRelationshipWithPepLabel(
                            applicant.politicallyExposedPersonStatus || ''
                          )}`}
                          description={applicant.relationshipWithPep}
                        />
                      )}
                      {applicant.panDeclaration ? (
                        <Grid item xs={12} display="flex" alignItems={'flex-start'} mt={1}>
                          {/* <Checkbox defaultChecked disabled={true} /> */}
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {
                              'I, hereby declare that I do not hold a Permanent Account Number (PAN) card. I am making this declaration in accordance with the requirements of Form 49BA under Income Tax Rules for the purpose of investment in Fund.I understand that not having a PAN card necessitates the submission of Form 49BA by the Registered Intermediary to fulfill the regulatory requirements for the transaction in question. I undertake to provide all necessary details and supporting documents as required by the relevant authorities.'
                            }
                          </Typography>
                        </Grid>
                      ) : (
                        <KeyValue title={'PAN'} description={applicant.pan} />
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
